import React from 'react';
import { Tabs as CTabs } from 'antd';
import type { TabsProps } from 'antd';
interface ITabsProps {
  items: TabsProps['items'];
  defaultActiveKey?: string;
  onChange: (key: string) => void;
  activeKey?: string
}

const Tabs: React.FC<ITabsProps> = ({ items, onChange, defaultActiveKey, activeKey }) => (
  <CTabs defaultActiveKey={defaultActiveKey} items={items} onChange={onChange} activeKey={activeKey} animated={{ inkBar: true, tabPane: false }}/>
);

export default Tabs;
